export default class Sliders {
    constructor() {
        this.sliders = document.querySelectorAll(".swiper")
        this.sliders.forEach( el => this.setup(el))
    }

    setup(_container) {
        let swiper = new Swiper(_container, {
            keyboard: {
                enabled: true,
            },
            pagination: {
                clickable: true,
                el: _container.querySelector('.pagination'),
                renderBullet: (index, className) => {
                    return '<span class="' + className + ' index-item">' + (index + 1) + "</span>"
                }
            },
            autoHeight: true,
            navigation: {
                nextEl: _container.querySelector('.button-next'),
                prevEl: _container.querySelector('.button-prev'),
            }
        }).on("slideChange", (idx) => {
            // let width = _container.querySelector('.pagination').getBoundingClientRect().width
            // let item = _container.querySelectorAll(".pagination-bullet")[swiper.activeIndex]
            // _container.querySelector('.pagination').scrollTo(item.offsetLeft, 0)
            // if (item.offsetLeft > _container.querySelector('.pagination').scrollLeft) {
            // }
        })
    }
}